import { createAction, props } from '@ngrx/store';
import { Tracking } from '@panamax/app-state';

export const DID_YOU_FORGET_TRACING_ACTIONS = {
  traceLoadPage: createAction(
    '[NGRXTrace - Order] DYF Page Load',
    props<{
      tracking: Tracking;
    }>(),
  ),
  fetchDyfProducts: createAction(
    '[NGRXTrace - Order] DYF Call',
    props<{
      tracking: Tracking;
    }>(),
  ),
  fetchDyfProductsFailure: createAction(
    '[NGRXTrace - Order] DYF Call Failure',
    props<{
      tracking: Tracking;
    }>(),
  ),
  fetchDyfProductsSuccess: createAction(
    '[NGRXTrace - Order] DYF Call Success',
    props<{
      tracking: Tracking;
    }>(),
  ),
};
